import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import { Hero, Link, Tile, Icon } from '@storaensods/seeds-react'
import get from 'lodash/get'
import { renderRichText } from '../utils'
import Layout from '../components/layout'
import HorizontalTiles from "../components/horizontal-tiles"
import "./index.css"

class RootIndex extends React.Component {
  render() {
    const page = get(this.props, 'data.contentfulPage')
    const horizontalTiles = get(this.props, 'data.horizontalTiles.edges');

    const options = {           
      horizontalTiles: (node) => {       
        const titleHorizontalTile = get(node, 'data.target.fields.title.en-US')
        const horizontalTile = horizontalTiles.find(({ node }) => node.title === titleHorizontalTile)
        return horizontalTile && <HorizontalTiles horizontalTile={horizontalTile} />
      }, 
    }

    return (
      <Layout location={this.props.location}>
        <Helmet title="Home | Stora Enso Design System" >
        <script async src={`https://www.googletagmanager.com/gtag/js?id=UA-157026851-1`} />
        <script>
        {`
           window.dataLayer = window.dataLayer || [];
           function gtag(){dataLayer.push(arguments);}
           gtag('js', new Date());
           gtag('config', 'UA-157026851-1');
        `}
        </script> 
        </Helmet>
        <div className="se-hero se-hero--md" style={{"backgroundImage":"url("+page.heroImage.resolutions.src+")"}}>
          <div className="se-hero-content-container container">
          <div className="se-hero-content">
            <div className="se-tile se-tile--yellow">
              {page && renderRichText(page.heroText.json)} 
            </div>
          </div>
          </div>
        </div>

        <div className="container">
        <div className="row">        
        {(page && page.tiles) ? (           
          <div className="col-lg-8">
            <div className="se-mb-xl ">
              {page && renderRichText(page.content.json, options)}
            </div>
          </div>) : ( <div className="col-lg-12 heading-centered-H3">
            <div className="se-mb-xl ">
              {page && renderRichText(page.content.json, options)}
            </div>
          </div>)}

            {page && page.tiles && (
              <div className="col-lg-4">
              <div className="srow">
                {page.tiles.map(tile => (
                  <div key={tile.title} className="scol-sm-4 se-mb-md">
                    <Tile color={tile.color} className="se-fullheight">
                      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <h3>{tile.title}</h3>
                        <div>
                          {renderRichText(tile.content.json)}
                        </div>
                        <Link
                          href={tile.linkUrl}
                          style={{ marginTop: 'auto' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Icon color="yellow">
                            chevron_right
                          </Icon>
                          <span>{tile.linkTitle}</span>
                        </Link>
                      </div>
                    </Tile>
                  </div>
                ))}
              </div>
              </div>
            )}          
          </div>
      
        {page && page.links && (
          <section className="se-mt-2xl se-mb-2xl">
            <div>
              {page.links.map(link => (
                <a
                  key={link.url}
                  className="se-btn se-btn--blue se-mr-lg"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.title}
                </a>
              ))}
            </div>
          </section>
        )}
          </div>
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    contentfulPage(slug: { eq: "home" }) {
      heroImage {
        resolutions(width: 1280) {
          src
        }
      }
      heroText {
        json
      }
      content {
        json
      }
      tiles {
        ...on ContentfulTile {
          title
          color
          content {
            json
          }
          linkTitle
          linkUrl
        }
      }
      links {
        ...on ContentfulLinkButton {
          title
          url
        }
      }
    }
    horizontalTiles: allContentfulHorizontalTiles {
      edges {
        node {
          id
          title
          tileItem {
            id
            color
            title
            linkTitle
            linkUrl
            content {
              json
            }
          }             
        }
      }
    }
  }
`
